import { Navigate, Route, Routes } from 'react-router-dom'
import { getToken } from './api/client'
import NavBar from './components/NavBar'
import ChartsPage from './pages/ChartsPage'
import DailyRecordPage from './pages/DailyRecordPage'
import FormulaPage from './pages/FormulaPage'
import LoginPage from './pages/LoginPage'
import RecordsPage from './pages/RecordsPage'

function Private({ children }) {
  if (!getToken()) return <Navigate to="/login" replace />
  return children
}

export default function App() {
  return (
    <div id="print-anchor" className="mx-auto min-h-screen max-w-3xl px-3 pb-24 pt-4">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/records"
          element={
            <Private>
              <RecordsPage />
            </Private>
          }
        />
        <Route
          path="/records/:date"
          element={
            <Private>
              <DailyRecordPage />
            </Private>
          }
        />
        <Route
          path="/charts"
          element={
            <Private>
              <ChartsPage />
            </Private>
          }
        />
        <Route
          path="/formula"
          element={
            <Private>
              <FormulaPage />
            </Private>
          }
        />
        <Route path="*" element={<Navigate to="/records" replace />} />
      </Routes>
      {getToken() && <NavBar />}
    </div>
  )
}
